import { render, staticRenderFns } from "./BeneficiaryField.vue?vue&type=template&id=27a3bbb5"
import script from "./BeneficiaryField.vue?vue&type=script&lang=js"
export * from "./BeneficiaryField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports